
import { send, cache_urls, clear } from './helpers';
import * as API from '../API/API';
const { fetch_api_json } = API;
import cleanDeps from './clean_deps';


// https://developer.mozilla.org/fr/docs/Web/API/CacheStorage
// https://developer.mozilla.org/fr/docs/Web/API/Cache
// https://developers.google.com/web/tools/workbox/guides/common-recipes
// https://web.dev/imperative-caching-guide/
// https://developers.google.com/web/tools/workbox/guides/advanced-recipes

window.API = API;

const DOMAIN_API = "/api/v1"

function user() {
  // img data etc. will be loaded w/ other users
  return fetch_api_json("get", "/user/me/");
}


// USERS //

function users() {
  return fetch_api_json("get", "/user/").then(({data}) => {
    return data.map(load_user);
  })
}

function load_user({ id }) {
  return fetch_api_json("get", "/user/"+id).then(x => {
    // load: load image (link in data received)
    return fetch(x.img);
  }).then(() => {
    const jid = `user-${id}@localhost`;
    // load avatar too
    return fetch(DOMAIN_API + "/conversejs/avatar/serve/" + jid);
  })
}


// POIS //

function themes() {
  // /poi_theme/ is not used, tree is
  return fetch_api_json("get", "/poi_theme/tree").then(all_themes => {

    // flatten tree
    const list = all_themes.flatMap(root => {
      return [root].concat(
        root.children.flatMap(subroot => {
          return [subroot].concat(subroot.children)
        })
      )
    })

    return list.map(x => loadTheme(x.id))
  })
}

function loadTheme(id) { API.getTheme(id); }


function contacts() {
  return API.getAllContact().then(({data}) => {
    return data.map(x => loadContact(x.id));
  })
}

function loadContact(id) {
  return API.getContact(id).then(x => {
    // load image too.
    // Problem for cache as image change
    return fetch(x.img);
  })
}


function entities()  {
  return API.getAllEntity().then(({data}) => {
    return data.map(x => loadEntity(x.id));
  })
}


function loadEntity(id) {
  return API.getEntity(id).then(x => {
    return fetch(x.img);
  })
}


// BOOKMARKS //


function bookmarks() {
  return API.getBookmark().then(ids => ids.map(loadPost))
}

function loadPost(id) {
  // only fetch the post itself, not any attachments for example
  return API.getPost(id)
}


function chainPromiseCb([initial_p, ...promises]) {
  if (! initial_p) return () => Promise.resolve(null);

  return () => {
    return promises.reduce((acc, p) => acc.then(p), initial_p())
  }
}

// OTHERS


function allFocus() {
  return Promise.all(
    ["/focus_entity", "/focus_contact", "/focus_theme"]
    .map(url => fetch_api_json("get", url))
  )
}

function allTrending() {
  return Promise.all(
    [1, 7, 30].map(API.getTrendingAll)
  )
}



function complexPreloadSw() {

  const loaders = [{
    name: "user",
    cb: user
  }, {
  //   DONE
  //   name: "users",
  //   cb: users
  // }, {
  //   name: "themes",
  //   cb: themes
  // }, {
  //   name: "contacts",
  //   cb: contacts
  // }, {
  //   name: "entities",
  //   cb: entities
  // }, {
    name: "bookmarks",
    cb: bookmarks
  // }, {
  //   DONE
  //   name: "focus",
  //   cb: allFocus
  // }, {
  //   name: "trending",
  //   cb: trending
  }];

  const fns = loaders.map(data => {
    return function() {
      console.log("[sw setup] Loading: " + data.name);
      return data.cb();
    }
  })

  const chained = chainPromiseCb(fns);

  return chained();
}


function preloadSw() {
  console.log("[sw] preload SW");

  const img_resps = [
    "/app_config/img/app_image",
    "/app_config/app_title",
    "/app_config/icon",
    // app_config
    // "/app_config/img/app_image",
    // (default image for entity and contact will be loaded w/ json list) + is not json
    // "/app_config/img/default_contact_image",
    // "/app_config/img/default_entity_image",
  ].map(url => fetch(url));

  const json_resps = [
  "/api/v1/user/me",
  "/api/v1/bookmark",
  "/api/v1/user",
  // pois: those are sync
  "/api/v1/poi_contact",
  "/api/v1/poi_entity",
  "/api/v1/poi_theme/tree",
  ].map(url => {
    return fetch(url, {
      method: "get",
      headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
    })
  })

  const promises_focus = allFocus();
  const promises_trending = allTrending();

  return img_resps.concat(json_resps).concat(promises_focus).concat(promises_trending);
}

window.preloadSw = preloadSw;

const setup = {
  user, users, themes, contacts, entities, bookmarks, allFocus, allTrending
}

window.setup = setup;


export { preloadSw };

export default preloadSw;



/*
sw_api.clear_cache() 
setup.themes();
*/

